import { getAlias } from "api/@teams/alias"

export const platformTeamsFetchAlias = () => {
  return async (dispatch) => {
    const data = await getAlias()
    if (!data.error) {
      dispatch({ type: "TEAMS_UPDATE_ALIAS", data })
    }
  }
}
